import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import Cropper from 'react-easy-crop';
import AddPopup from '../../EditPopup/Addpopup';
import CategoryPopup from '../../EditPopup/CategoryPopup';
import EditPersonalPopup from '../../EditPopup/EditPersonalPopup';
import EditAppearancePopup from '../../EditPopup/UpdateAppearance';
import {
  updateAboutContent,
  updateInterestContent,
  updateTalentsContent,
  updateHobbiesContent,
  updateAgeContent,
  updateLocationContent,
  updateEthnicityContent,
  updateHeightContent,
  updateWeightContent,
  updateHairColorContent,
  updateEyeColorContent,
  updateActorCategoryContent,
  updateDirectorAboutContent,
  updateDirectorCategoryContent,
  updateDirectorCompanyName,
  updateDirectorLocation,
  updateGender,
  updateCrewAboutContent,
  updateCrewCategoryContent,
  updateCrewIndustryJob,
  updateCrewAge,
  updateCrewLocation,
  updateCrewEthnicity,
  updateCrewGender,
  getSingleUser,
  updateUserSliderImages,
  deleteUserSliderImage
} from '../../../api/axios';
import Alert from '../../common/Alert';

const MAX_SLIDER_IMAGES = 5;

const ethnicities = [
  {
    value: 'black',
    label: 'African American',
  },
  // {
  //   value: "white",
  //   label: "White",
  // },
  {
    value: 'asian',
    label: 'Asian',
  },
  {
    value: 'latino/hispanic',
    label: 'Latino Hispanic',
  },
  {
    value: 'white/caucasian',
    label: 'European American',
  },
  {
    value: 'middle_eastern',
    label: 'Middle Eastern',
  },
  {
    value: 'native_american',
    label: 'Native American',
  },
  {
    value: 'pacific_islander',
    label: 'Pacific Islander',
  },
  {
    value: 'indian/south_asian',
    label: 'Indian South Asian',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

const ProfileInfo = ({ userDetails, userId, role }) => {
  // console.log('User Details :' + JSON.stringify(userDetails, null, 2));
  const userOtherDetails = userDetails?.result || {};
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  const [categoryContent, setCategoryContent] = useState(() => {
    if (role === 'crew' && userOtherDetails.category) {
      return userOtherDetails.category.split(', ').filter(Boolean);
    }
    return userOtherDetails.category || '';
  });
  const [isCategoryPopupVisible, setCategoryPopupVisible] = useState(false);
  const [companyName, setCompanyName] = useState(
    userOtherDetails.companyName || ''
  );
  const [location, setLocation] = useState(userOtherDetails.location || '');
  const [isCompanyPopupVisible, setCompanyPopupVisible] = useState(false);
  const [isLocationPopupVisible, setLocationPopupVisible] = useState(false);
  const [isAboutPopupVisible, setAboutPopupVisible] = useState(false);
  const [isInterestPopupVisible, setInterestPopupVisible] = useState(false);
  const [isTalentPopupVisible, setTalentPopupVisible] = useState(false);
  const [isHobbiesPopupVisible, setHobbiesPopupVisible] = useState(false);
  const [isAppearancePopupVisible, setAppearancePopupVisible] = useState(false);
  const [isPersonalPopupVisible, setPersonalPopupVisible] = useState(false);
  const [isIndustryJobPopupVisible, setIndustryJobPopupVisible] =
    useState(false);
  const [industryJobContent, setIndustryJobContent] = useState(
    userOtherDetails.industryJob || ''
  );
  const [aboutContent, setAboutContent] = useState(
    userOtherDetails.about || ''
  );
  const [interestContent, setInterestContent] = useState(
    userOtherDetails.interestedIn || ''
  );
  const [talentContent, setTalentContent] = useState(
    userOtherDetails.talents || ''
  );
  const [hobbiesContent, setHobbiesContent] = useState(
    userOtherDetails.hobbies || ''
  );
  const [personalInfo, setPersonalInfo] = useState({
    age: userOtherDetails.age || '',
    location: userOtherDetails.location || '',
    ethnicity:
      userOtherDetails.ethnicity ||
      userDetails?.registerResult?.ethnicity ||
      '',
    gender:
      userDetails.registerResult?.gender || userDetails.result?.gender || '',
  });

  const [appearanceInfo, setAppearanceInfo] = useState({
    height: userOtherDetails.height || '',
    weight: userOtherDetails.weight || '',
    hairColor: userOtherDetails.hairColor || '',
    eyeColor: userOtherDetails.eyeColor || '',
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  // Add new state variables for image upload functionality
  const [imageURL, setImageURL] = useState([]);
  // console.log('imageURL: ', imageURL);
  const [selectedImages, setSelectedImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isCropping, setIsCropping] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const openCategoryPopup = () => setCategoryPopupVisible(true);
  const closeCategoryPopup = () => setCategoryPopupVisible(false);

  const openCompanyPopup = () => setCompanyPopupVisible(true);
  const closeCompanyPopup = () => setCompanyPopupVisible(false);

  const openLocationPopup = () => setLocationPopupVisible(true);
  const closeLocationPopup = () => setLocationPopupVisible(false);

  const openIndustryJobPopup = () => setIndustryJobPopupVisible(true);
  const closeIndustryJobPopup = () => setIndustryJobPopupVisible(false);

  const getEthnicityLabel = (value) => {
    const ethnicity = ethnicities.find((e) => e.value === value);
    return ethnicity ? ethnicity.label : ''; // Return label if found, otherwise "Unknown"
  };

  const normalizeImages = (value) => {
    try {
      if (Array.isArray(value)) {
        return value
          .flatMap((item) => normalizeImages(item))
          .filter(Boolean);
      }

      if (typeof value === 'string' && value.trim()) {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return parsed.filter(Boolean);
          }
        } catch (e) {
          return [value];
        }
      }

      if (value && typeof value === 'object') {
        return normalizeImages(
          value.url || value.imageUrl || value.imageURL || value.src || ''
        );
      }

      return [];
    } catch (error) {
      console.error('Error processing images:', error);
      return [];
    }
  };

  const storedImages = normalizeImages(
    imageURL?.length ? imageURL : userDetails?.result?.images
  );
  const remainingSlots = Math.max(
    0,
    MAX_SLIDER_IMAGES - storedImages.length - selectedImages.length
  );

  // Fetch existing images when component mounts
  useEffect(() => {
    const fetchUserImages = async () => {
      try {
        const userData = await getSingleUser(userId);
        setImageURL(normalizeImages(userData?.user?.images));
      } catch (error) {
        console.error('Error fetching user images:', error);
      }
    };

    fetchUserImages();
  }, [userId]);

  // Handle file selection
  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    if (remainingSlots <= 0) {
      setAlertSeverity('error');
      setAlertMessage(`You can upload a maximum of ${MAX_SLIDER_IMAGES} slider images.`);
      setOpenSnackbar(true);
      e.target.value = '';
      return;
    }

    const filesToAdd = files.slice(0, remainingSlots);

    if (files.length > remainingSlots) {
      setAlertSeverity('error');
      setAlertMessage(
        `Only ${remainingSlots} more image${remainingSlots === 1 ? '' : 's'} can be added.`
      );
      setOpenSnackbar(true);
    }

    const newImages = filesToAdd.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(newImages).then((images) => {
      setSelectedImages((prevImages) => [...prevImages, ...images]);
    });
    e.target.value = '';
  };

  // Handle crop complete
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Get cropped image
  const getCroppedImage = async () => {
    if (!croppedAreaPixels) return null;

    try {
      const image = new Image();
      image.src = selectedImages[currentImageIndex];

      // Wait for image to load
      await new Promise((resolve) => {
        image.onload = resolve;
      });

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg');
      });
    } catch (e) {
      console.error('Error creating cropped image:', e);
      return null;
    }
  };

  // Handle upload of images
  const handleUpload = async () => {
    setIsUploading(true);
    try {
      if (storedImages.length + selectedImages.length > MAX_SLIDER_IMAGES) {
        setAlertSeverity('error');
        setAlertMessage(`You can upload a maximum of ${MAX_SLIDER_IMAGES} slider images.`);
        setOpenSnackbar(true);
        return;
      }

      const formData = new FormData();

      // Process each selected image
      for (let i = 0; i < selectedImages.length; i++) {
        let imageBlob;

        // If current image is being cropped
        if (i === currentImageIndex && isCropping) {
          const croppedBlob = await getCroppedImage();
          if (croppedBlob) {
            imageBlob = croppedBlob;
          }
        } else {
          // Convert base64 to blob for other images
          const res = await fetch(selectedImages[i]);
          imageBlob = await res.blob();
        }

        formData.append('images', imageBlob, `image-${i}.jpg`);
      }

      // console.log('FormData to be uploaded----------:', formData);

      // Upload images
      await updateUserSliderImages(userId, formData);

      // Refresh the displayed images
      const updatedUserData = await getSingleUser(userId);
      setImageURL(normalizeImages(updatedUserData?.user?.images));

      // Reset states
      setSelectedImages([]);
      setCurrentImageIndex(0);
      setIsCropping(false);
      setZoom(1);
      setCrop({ x: 0, y: 0 });

      // Show success message
      setAlertSeverity('success');
      setAlertMessage('Images uploaded successfully!');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error uploading images:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to upload images.');
      setOpenSnackbar(true);
    } finally {
      setIsUploading(false);
    }
  };

  // Remove image from selected images
  const removeSelectedImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
    if (currentImageIndex >= index && currentImageIndex > 0) {
      setCurrentImageIndex((prev) => prev - 1);
    }
  };

  // Delete uploaded image
  const deleteImage = async (imageUrl) => {
    try {
      const response = await deleteUserSliderImage(userId, imageUrl);
      const updatedImages = normalizeImages(response?.result?.updatedUser?.images);
      setImageURL(updatedImages);

      setAlertSeverity('success');
      setAlertMessage('Image deleted successfully!');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error deleting image:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to delete image.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "About" section content
  const handleAddAbout = async (newContent) => {
    try {
      let response;
      // console.log('User role: ', role);

      if (userRole === 'director' || userRole === 'producer') {
        response = await updateDirectorAboutContent(userId, newContent, token);
        // console.log('Director API Response:', response);
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage("Director's About section updated successfully.");
        } else {
          setAlertSeverity('error');
          setAlertMessage(
            response.message || "Failed to update Director's About section."
          );
        }
      } else if (role === 'actor') {
        response = await updateAboutContent(userId, newContent);
        // console.log('Actor API Response:', response);
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage('About section updated successfully.');
        } else {
          setAlertSeverity('error');
          setAlertMessage(
            response.message || 'Failed to update About section.'
          );
        }
      } else if (role === 'crew') {
        response = await updateCrewAboutContent(userId, newContent);
        // console.log('Crew API Response:', response);
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage('About section updated successfully.');
        } else {
          setAlertSeverity('error');
          setAlertMessage(
            response.message || 'Failed to update About section.'
          );
        }
      } else {
        console.error('Unexpected role value:', role);
        throw new Error('Invalid role');
      }

      setOpenSnackbar(true);
      setAboutContent(newContent); // Optionally update the local state
    } catch (error) {
      console.error('Error updating About section:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to update About section.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "Interested In" section content
  const handleAddInterest = async (newContent) => {
    try {
      const response = await updateInterestContent(userId, newContent);
      // console.log('API Response:', response);
      if (response.success) {
        // Set alert for success
        setAlertSeverity('success');
        setAlertMessage('Interested In section updated successfully.');
        setOpenSnackbar(true);

        setInterestContent(newContent);
      } else {
        // Set alert for failure
        setAlertSeverity('error');
        setAlertMessage(
          response.message || 'Failed to update Interested In section.'
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating Interested In section:', error);

      setAlertSeverity('error');
      setAlertMessage('Failed to update Interested In section.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "Talents" section content
  const handleAddTalent = async (newContent) => {
    try {
      const response = await updateTalentsContent(userId, newContent);
      // console.log('API Response:', response);
      if (response.success) {
        // Set alert for success
        setAlertSeverity('success');
        setAlertMessage('Talents section updated successfully.');
        setOpenSnackbar(true);
        setTalentContent(newContent);
      } else {
        // Set alert for failure
        setAlertSeverity('error');
        setAlertMessage(
          response.message || 'Failed to update Talents section.'
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating Talents section:', error);

      setAlertSeverity('error');
      setAlertMessage('Failed to update Talents section.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "Category" section content
  const handleAddCategory = async (newContent) => {
    try {
      if (role === 'director' || role === 'producer') {
        const response = await updateDirectorCategoryContent(
          userId,
          newContent
        );
        // console.log('API Response:', response);
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage('Category updated successfully.');
          setCategoryContent(newContent); // Update local state with new category
        } else {
          setAlertSeverity('error');
          setAlertMessage(response.message || 'Failed to update category.');
        }
        setOpenSnackbar(true);
      } else if (role === 'crew') {
        const contentToSend = Array.isArray(newContent) ? newContent.join(', ') : newContent;
        const response = await updateCrewCategoryContent(userId, contentToSend);
        // console.log('API Response:', response);
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage('Category updated successfully.');
          setCategoryContent(newContent); // Update local state with the array of new categories
        } else {
          setAlertSeverity('error');
          setAlertMessage(response.message || 'Failed to update category.');
        }
        setOpenSnackbar(true);
      } else if (role === 'actor') {
        const contentToSend = Array.isArray(newContent)
          ? newContent.join(', ')
          : newContent;
        const response = await updateActorCategoryContent(
          userId,
          contentToSend
        );
        if (response.success) {
          setAlertSeverity('success');
          setAlertMessage('Category updated successfully.');
          setCategoryContent(contentToSend);
        } else {
          setAlertSeverity('error');
          setAlertMessage(response.message || 'Failed to update category.');
        }
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating category:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to update category.');
      setOpenSnackbar(true);
    }
    closeCategoryPopup(); // Close the popup after handling
  };

  const handleUpdateCompany = async (newCompanyName) => {
    try {
      const response = await updateDirectorCompanyName(userId, newCompanyName);
      if (response.success) {
        setAlertSeverity('success');
        setAlertMessage('Company Name updated successfully.');
        setCompanyName(newCompanyName);
      } else {
        setAlertSeverity('error');
        setAlertMessage(response.message || 'Failed to update Company Name.');
      }
      setOpenSnackbar(true);
    } catch (error) {
      setAlertSeverity('error');
      setAlertMessage('Failed to update Company Name.');
      setOpenSnackbar(true);
    }
    closeCompanyPopup();
  };

  const handleUpdateCrewIndustryJob = async (newIndustryJob) => {
    try {
      // console.log('Token is : ', token);
      const response = await updateCrewIndustryJob(
        userId,
        newIndustryJob,
        token
      );
      if (response.success) {
        setAlertSeverity('success');
        setAlertMessage('Business Name updated successfully.');
        setIndustryJobContent(newIndustryJob);
      } else {
        setAlertSeverity('error');
        setAlertMessage(response.message || 'Failed to update Business Name.');
      }
      setOpenSnackbar(true);
    } catch (error) {
      setAlertSeverity('error');
      setAlertMessage('Failed to update Business Name.');
      setOpenSnackbar(true);
    }
    closeIndustryJobPopup();
  };

  const handleUpdateLocation = async (newLocation) => {
    try {
      const response = await updateDirectorLocation(userId, newLocation);
      if (response.success) {
        setAlertSeverity('success');
        setAlertMessage('Location updated successfully.');
        setLocation(newLocation);
      } else {
        setAlertSeverity('error');
        setAlertMessage(response.message || 'Failed to update Location.');
      }
      setOpenSnackbar(true);
    } catch (error) {
      setAlertSeverity('error');
      setAlertMessage('Failed to update Location.');
      setOpenSnackbar(true);
    }
    closeLocationPopup();
  };

  // Handle the addition or editing of the "Hobbies" section content
  const handleAddHobbies = async (newContent) => {
    try {
      const response = await updateHobbiesContent(userId, newContent);
      // console.log('API Response:', response);
      if (response.success) {
        // Set alert for success
        setAlertSeverity('success');
        setAlertMessage('Hobbies section updated successfully.');
        setOpenSnackbar(true);
        setHobbiesContent(newContent);
      } else {
        // Set alert for failure
        setAlertSeverity('error');
        setAlertMessage(
          response.message || 'Failed to update Hobbies section.'
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating Hobbies section:', error);

      setAlertSeverity('error');
      setAlertMessage('Failed to update Hobbies section.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "Personal" section content
  const handleUpdatePersonalInfo = async (updatedInfo) => {
    // console.log('Role: ', role);
    try {
      let ageResponse;
      let locationResponse;
      let ethnicityResponse;
      let genderResponse;

      if (role === 'crew') {
        // [ageResponse, locationResponse, ethnicityResponse, genderResponse] =
        //   await Promise.all([
        //     updateCrewAge(userId, updatedInfo.age, token),
        //     updateCrewLocation(userId, updatedInfo.location, token),
        //     updateCrewEthnicity(userId, updatedInfo.ethnicity, token),
        //     updateCrewGender(userId, updatedInfo.gender, token),
        //   ]);
        ageResponse = await updateCrewAge(userId, updatedInfo.age, token);
        locationResponse = await updateCrewLocation(
          userId,
          updatedInfo.location,
          token
        );
        ethnicityResponse = await updateCrewEthnicity(
          userId,
          updatedInfo.ethnicity,
          token
        );
        genderResponse = await updateCrewGender(
          userId,
          updatedInfo.gender,
          token
        );
        // console.log('Age Update Response:', ageResponse);
        // console.log('Location Update Response:', locationResponse);
        // console.log('Ethnicity Update Response:', ethnicityResponse);
        // console.log('Gender Update Response', genderResponse);
      } else {
        ageResponse = await updateAgeContent(userId, updatedInfo.age, token);
        locationResponse = await updateLocationContent(
          userId,
          updatedInfo.location,
          token
        );
        ethnicityResponse = await updateEthnicityContent(
          userId,
          updatedInfo.ethnicity,
          token
        );
        genderResponse = await updateGender(userId, updatedInfo.gender, token);
        // console.log('Age Update Response:', ageResponse);
        // console.log('Location Update Response:', locationResponse);
        // console.log('Ethnicity Update Response:', ethnicityResponse);
        // console.log('Gender Update Response', genderResponse);
      }

      if (
        ageResponse.success &&
        locationResponse.success &&
        ethnicityResponse.success &&
        genderResponse.success
      ) {
        // Set alert for success
        setAlertSeverity('success');
        setAlertMessage('Personal information updated successfully.');
        setOpenSnackbar(true);
        // console.log('updatedInfo pass to teh personal info', updatedInfo);
        setPersonalInfo(updatedInfo);
      } else {
        // Handle partial or full failure
        setAlertSeverity('error');
        setAlertMessage(
          'Failed to update one or more parts of the Personal section.'
        );
        setOpenSnackbar(true);
      }

      // const [ageResponse, locationResponse, ethnicityResponse, genderResponse] =
      //   await Promise.all([
      //     updateAgeContent(userId, updatedInfo.age),
      //     updateLocationContent(userId, updatedInfo.location),
      //     updateEthnicityContent(userId, updatedInfo.ethnicity),
      //     updateGender(userId, updatedInfo.gender),
      //   ]);
      // // console.log("Age Update Response:", ageResponse);
      // // console.log("Location Update Response:", locationResponse);
      // // console.log("Ethnicity Update Response:", ethnicityResponse);
      // // console.log("Gender Update Response", genderResponse);
      // if (
      //   ageResponse.success &&
      //   locationResponse.success &&
      //   ethnicityResponse.success &&
      //   genderResponse.success
      // ) {
      //   // Set alert for success
      //   setAlertSeverity("success");
      //   setAlertMessage("Personal information updated successfully.");
      //   setOpenSnackbar(true);
      //   // console.log("updatedInfo pass to teh personal info", updatedInfo);
      //   setPersonalInfo(updatedInfo);
      // } else {
      //   // Handle partial or full failure
      //   setAlertSeverity("error");
      //   setAlertMessage(
      //     "Failed to update one or more parts of the Personal section."
      //   );
      //   setOpenSnackbar(true);
      // }
    } catch (error) {
      console.error('Error updating Personal section:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to update Personal information.');
      setOpenSnackbar(true);
    }
  };

  // Handle the addition or editing of the "Appearance" section content
  const handleUpdateAppearanceInfo = async (updatedInfo) => {
    try {
      const [
        heightResponse,
        weightResponse,
        hairColorResponse,
        eyeColorResponse,
      ] = await Promise.all([
        updateHeightContent(userId, updatedInfo.height),
        updateWeightContent(userId, updatedInfo.weight),
        updateHairColorContent(userId, updatedInfo.hairColor),
        updateEyeColorContent(userId, updatedInfo.eyeColor),
      ]);
      // console.log('Height Update Response:', heightResponse);
      // console.log('Weight Update Response:', weightResponse);
      // console.log('Hair Color Update Response:', hairColorResponse);
      // console.log('Eye Color Update Response:', eyeColorResponse);

      if (
        heightResponse.success &&
        weightResponse.success &&
        hairColorResponse.success &&
        eyeColorResponse.success
      ) {
        // Set alert for success
        setAlertSeverity('success');
        setAlertMessage('Appearance information updated successfully.');
        setOpenSnackbar(true);

        setAppearanceInfo(updatedInfo);
      } else {
        // Handle partial or full failure
        setAlertSeverity('error');
        setAlertMessage(
          'Failed to update one or more parts of the Appearance section.'
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating Appearance section:', error);

      setAlertSeverity('error');
      setAlertMessage('Failed to update Appearance information.');
      setOpenSnackbar(true);
    }
  };

  // Functions to open and close the popups
  const openAboutPopup = () => setAboutPopupVisible(true);
  const closeAboutPopup = () => setAboutPopupVisible(false);
  const openInterestPopup = () => setInterestPopupVisible(true);
  const closeInterestPopup = () => setInterestPopupVisible(false);
  const openTalentPopup = () => setTalentPopupVisible(true);
  const closeTalentPopup = () => setTalentPopupVisible(false);
  const openHobbiesPopup = () => setHobbiesPopupVisible(true);
  const closeHobbiesPopup = () => setHobbiesPopupVisible(false);
  const openPersonalPopup = () => setPersonalPopupVisible(true);
  const closePersonalPopup = () => setPersonalPopupVisible(false);
  const openAppearancePopup = () => setAppearancePopupVisible(true);
  const closeAppearancePopup = () => setAppearancePopupVisible(false);

  return (
    <>
      <div className='log-profile-info'>
        {/* Add the Images section */}
        <div className='log-info-container'>
          <div className='log-info-images-title'>
            <span>Slider Images ({storedImages.length}/{MAX_SLIDER_IMAGES})</span>
            <input
              type='file'
              id='image-upload'
              accept='image/*'
              multiple
              onChange={handleImageSelect}
              style={{ display: 'none' }}
            />
            <label
              htmlFor='image-upload'
              className='upload-images-button'
              style={{
                pointerEvents: remainingSlots === 0 ? 'none' : 'auto',
                opacity: remainingSlots === 0 ? 0.6 : 1,
              }}
            >
              <FontAwesomeIcon icon={faPlus} /> Select Images
            </label>
          </div>

          {/* Display uploaded images */}
          <div className='profile-images-gallery'>
            {storedImages.length > 0 ? (
              <div className='uploaded-images-grid'>
                {storedImages.map((image, index) => (
                  <div key={index} className='image-container'>
                    <img
                      src={image}
                      alt={`User uploaded image ${index + 1}`}
                      className='gallery-image'
                    />
                    <button
                      className='delete-image-btn'
                      onClick={() => deleteImage(image)}
                      type='button'
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p className='no-images-text'>No images uploaded yet.</p>
            )}
          </div>

          {/* Image upload section */}
          {selectedImages.length > 0 && (
            <div className='image-upload-section'>
              <div className='selected-images-preview'>
                <h4>Selected Images ({selectedImages.length})</h4>

                <div className='selected-images-thumbnails'>
                  {selectedImages.map((image, index) => (
                    <div
                      key={index}
                      className={`thumbnail-images-container ${
                        index === currentImageIndex ? 'active' : ''
                      }`}
                      onClick={() => setCurrentImageIndex(index)}
                    >
                      <img
                        src={image}
                        alt={`Selected image ${index + 1}`}
                        className='thumbnail'
                      />
                      <button
                        className='remove-image-btn'
                        onClick={(e) => {
                          e.stopPropagation();
                          removeSelectedImage(index);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  ))}
                </div>

                {selectedImages.length > 0 && (
                  <div className='current-image-container'>
                    {isCropping ? (
                      <div className='crop-container'>
                        <Cropper
                          image={selectedImages[currentImageIndex]}
                          crop={crop}
                          zoom={zoom}
                          aspect={1} // or any other aspect ratio
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          onCropComplete={onCropComplete}
                        />
                      </div>
                    ) : (
                      <img
                        src={selectedImages[currentImageIndex]}
                        alt='Current selected'
                        className='current-image'
                      />
                    )}
                  </div>
                )}

                <div className='image-actions'>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <button
                      onClick={() => setIsCropping(!isCropping)}
                      className='upload-images-button'
                    >
                      {isCropping ? 'Cancel Crop' : 'Crop Image'}
                    </button>
                     <input
                       type='file'
                       id='image-upload-more'
                       accept='image/*'
                       multiple
                       onChange={handleImageSelect}
                       style={{ display: 'none' }}
                     />
                     <label
                       htmlFor='image-upload-more'
                       className='upload-images-button'
                       style={{
                         cursor: remainingSlots === 0 ? 'not-allowed' : 'pointer',
                         margin: '0px',
                         pointerEvents: remainingSlots === 0 ? 'none' : 'auto',
                         opacity: remainingSlots === 0 ? 0.6 : 1,
                       }}
                     >
                       <FontAwesomeIcon icon={faPlus} /> Select Images
                     </label>
                   </div>
                  <button
                    onClick={handleUpload}
                    className='upload-images-button'
                    disabled={isUploading || selectedImages.length === 0}
                  >
                    {isUploading ? 'Uploading...' : 'Upload Images'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='log-info-container'>
          <div className='log-info-title'>
            <span>ABOUT:</span>
            <FontAwesomeIcon
              icon={faEdit}
              onClick={openAboutPopup}
              className='editIcon'
            />
          </div>
          <div className='log-profile-details-box'>
            <p>
              {aboutContent || 'Introduce your Profile to the community...'}
            </p>
            {!aboutContent && (
              <span
                className='log-add-link'
                onClick={(e) => {
                  e.preventDefault();
                  openAboutPopup();
                }}
              >
                Add
              </span>
            )}
          </div>
        </div>

        <div className='log-info-row'>
          {/* INTERESTED IN Section */}
          {userDetails.registerResult?.role !== 'director' &&
            userDetails.registerResult?.role !== 'producer' &&
            userDetails.registerResult?.role !== 'crew' && (
              <div className='log-info-container'>
                <div className='log-info-title'>
                  <span>INTERESTED IN:</span>
                  <FontAwesomeIcon
                    icon={faEdit}
                    onClick={openInterestPopup}
                    className='editIcon'
                  />
                </div>
                <div className='log-profile-details-box'>
                  <p
                    className={`personal-info-value ${
                      !interestContent ? 'faded' : ''
                    }`}
                  >
                    {interestContent
                      ? interestContent.replace(/,(?!\s)/g, ', ')
                      : 'Share your favorite activities here...'}
                  </p>
                  {!interestContent && (
                    <span
                      className='log-add-link'
                      onClick={(e) => {
                        e.preventDefault();
                        openInterestPopup();
                      }}
                    >
                      Add
                    </span>
                  )}
                </div>
              </div>
            )}

          {/* TALENTS Section */}
          {userDetails.registerResult?.role !== 'director' &&
            userDetails.registerResult?.role !== 'producer' &&
            userDetails.registerResult?.role !== 'crew' && (
              <div className='log-info-container'>
                <div className='log-info-title'>
                  <span>TALENTS:</span>
                  <FontAwesomeIcon
                    icon={faEdit}
                    onClick={openTalentPopup}
                    className='editIcon'
                  />
                </div>
                <div className='log-profile-details-box'>
                  <p
                    className={`personal-info-value ${
                      !talentContent ? 'faded' : ''
                    }`}
                  >
                    {talentContent ? talentContent?.replace(/,(?!\s)/g, ', ') : 'List your skills and strengths... '}
                  </p>
                  {!talentContent && (
                    <span
                      className='log-add-link'
                      onClick={(e) => {
                        e.preventDefault();
                        openTalentPopup();
                      }}
                    >
                      Add
                    </span>
                  )}
                </div>
              </div>
            )}
        </div>

        {/* HOBBIES Section */}
        {userDetails.registerResult?.role !== 'director' &&
          userDetails.registerResult?.role !== 'producer' &&
          userDetails.registerResult?.role !== 'crew' && (
            <div className='log-info-container'>
              <div className='log-info-title'>
                <span>HOBBIES:</span>
                <FontAwesomeIcon
                  icon={faEdit}
                  onClick={openHobbiesPopup}
                  className='editIcon'
                />
              </div>
              <div className='log-profile-details-box'>
                <p
                  className={`personal-info-value ${
                    !hobbiesContent ? 'faded' : ''
                  }`}
                >
                  {hobbiesContent ? hobbiesContent?.replace(/,(?!\s)/g, ', ') : 'Share your favorite hobbies here...'}
                </p>
                {!hobbiesContent && (
                  <span
                    className='log-add-link'
                    onClick={(e) => {
                      e.preventDefault();
                      openHobbiesPopup();
                    }}
                  >
                    Add
                  </span>
                )}
              </div>
            </div>
          )}

        {/* PERSONAL Section */}
        {userDetails.registerResult?.role !== 'director' &&
          userDetails.registerResult?.role !== 'producer' && (
            <div className='log-info-container'>
              <div className='log-info-title'>
                <span>PERSONAL:</span>
                <FontAwesomeIcon
                  icon={faEdit}
                  onClick={openPersonalPopup}
                  className='editIcon'
                />
              </div>
              <div className='log-profile-details-box personal-info-row'>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Age</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.age ? 'faded' : ''
                    }`}
                    placeholder='Add age'
                  >
                    {personalInfo.age || 'Add Age'}
                  </p>
                </div>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Location</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.location ? 'faded' : ''
                    }`}
                  >
                    {personalInfo.location || 'Add location'}
                  </p>
                </div>
                {role !== 'crew' && (
                  <div className='personal-info-item'>
                    <p className='personal-info-label'>Ethnicity</p>
                    <p
                      className={`personal-info-value ${
                        !personalInfo.ethnicity ? 'faded' : ''
                      }`}
                    >
                      {/* {personalInfo.ethnicity || "Add ethnicity"} */}
                      {getEthnicityLabel(personalInfo.ethnicity) ||
                        'Add ethnicity'}
                    </p>
                  </div>
                )}

                <div className='personal-info-item'>
                  <p className='personal-info-label'>Gender</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.gender ? 'faded' : ''
                    }`}
                  >
                    {personalInfo.gender?.charAt(0).toUpperCase() +
                      personalInfo.gender?.slice(1) || 'Add gender'}
                  </p>
                </div>
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openPersonalPopup();
                  }}
                >
                  Edit
                </span>
              </div>
            </div>
          )}

        {/* CATEGORY Section */}
        {(userDetails.registerResult?.role === 'director' ||
          userDetails.registerResult?.role === 'producer' ||
          userDetails.registerResult?.role === 'crew'||userDetails.registerResult?.role === 'actor') && (
          <div className='log-info-container'>
            <div className='log-info-title'>
              <span>Job Title:</span>
              <FontAwesomeIcon
                icon={faEdit}
                onClick={openCategoryPopup}
                className='editIcon'
              />
            </div>
            <div className='log-profile-details-box'>
              <p>
                {role === 'crew' && Array.isArray(categoryContent)
                  ? categoryContent.join(', ')
                  : categoryContent || 'Add category here...'}
              </p>
              {!(
                (role === 'crew' && Array.isArray(categoryContent) && categoryContent.length > 0) ||
                (role !== 'crew' && categoryContent)
              ) && (
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openCategoryPopup();
                  }}
                >
                  Add
                </span>
              )}
            </div>
          </div>
        )}

        {userDetails.registerResult?.role === 'crew' && (
          <div className='log-info-container'>
            <div className='log-info-title'>
              <span>Business Name:</span>
              <FontAwesomeIcon
                icon={faEdit}
                onClick={openIndustryJobPopup}
                className='editIcon'
              />
            </div>
            <div className='log-profile-details-box'>
              <p>{industryJobContent || 'Add industry job here...'}</p>
              {!industryJobContent && (
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openIndustryJobPopup();
                  }}
                >
                  Add
                </span>
              )}
            </div>
          </div>
        )}

        {/* COMPANY NAME Section */}
        {(userDetails.registerResult?.role === 'director' ||
          userDetails.registerResult?.role === 'producer') && (
          <div className='log-info-container'>
            <div className='log-info-title'>
              <span>COMPANY NAME:</span>
              <FontAwesomeIcon
                icon={faEdit}
                onClick={openCompanyPopup}
                className='editIcon'
              />
            </div>
            <div className='log-profile-details-box'>
              <p>{companyName || 'Add company name here...'}</p>
              {!companyName && (
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openCompanyPopup();
                  }}
                >
                  Add
                </span>
              )}
            </div>
          </div>
        )}

        {/* LOCATION Section */}
        {(userDetails.registerResult?.role === 'director' ||
          userDetails.registerResult?.role === 'producer') && (
          <div className='log-info-container'>
            <div className='log-info-title'>
              <span>LOCATION:</span>
              <FontAwesomeIcon
                icon={faEdit}
                onClick={openLocationPopup}
                className='editIcon'
              />
            </div>
            <div className='log-profile-details-box'>
              <p>{location || 'Add location here...'}</p>
              {!location && (
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openLocationPopup();
                  }}
                >
                  Add
                </span>
              )}
            </div>
          </div>
        )}

        {/* APPEARANCE Section */}
        {userDetails.registerResult?.role !== 'director' &&
          userDetails.registerResult?.role !== 'producer' &&
          userDetails.registerResult?.role !== 'crew' && (
            <div className='log-info-container'>
              <div className='log-info-title'>
                <span>APPEARANCE:</span>
                <FontAwesomeIcon
                  icon={faEdit}
                  onClick={openAppearancePopup}
                  className='editIcon'
                />
              </div>
              <div className='log-profile-details-box personal-info-row'>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Height</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.height ? '' : ''
                    }`}
                  >
                    {appearanceInfo.height || 'Add height'}
                  </p>
                </div>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Weight</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.weight ? '' : ''
                    }`}
                  >
                    {appearanceInfo.weight || 'Add weight'}
                  </p>
                </div>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Hair Color</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.hairColor ? '' : ''
                    }`}
                  >
                    {appearanceInfo.hairColor || 'Add hair color'}
                  </p>
                </div>
                <div className='personal-info-item'>
                  <p className='personal-info-label'>Eye Color</p>
                  <p
                    className={`personal-info-value ${
                      !personalInfo.eyeColor ? '' : ''
                    }`}
                  >
                    {appearanceInfo.eyeColor || 'Add eye color'}
                  </p>
                </div>
                <span
                  className='log-add-link'
                  onClick={(e) => {
                    e.preventDefault();
                    openAppearancePopup();
                  }}
                >
                  Edit
                </span>
              </div>
            </div>
          )}
      </div>

      {/* Popup Components */}
      {isAboutPopupVisible && (
        <AddPopup
          onClose={closeAboutPopup}
          onAdd={handleAddAbout}
          initialContent={aboutContent}
          title='Edit About Section'
          label='About'
        />
      )}
      {isCategoryPopupVisible && (
        <CategoryPopup
          onClose={closeCategoryPopup}
          onAdd={handleAddCategory}
          initialSelection={categoryContent}
          title={role === 'crew' ? 'Edit Job Title' : 'Edit Category'}
          label={role === 'crew' ? 'Job Title' : 'Category'}
          role={role}
        />
      )}
      {isInterestPopupVisible && (
        <AddPopup
          onClose={closeInterestPopup}
          onAdd={handleAddInterest}
          initialContent={interestContent}
          title='Edit Interested In Section'
          label='Interested In'
        />
      )}
      {isTalentPopupVisible && (
        <AddPopup
          onClose={closeTalentPopup}
          onAdd={handleAddTalent}
          initialContent={talentContent}
          title='Edit Talents Section'
          label='Talents'
        />
      )}
      {isHobbiesPopupVisible && (
        <AddPopup
          onClose={closeHobbiesPopup}
          onAdd={handleAddHobbies}
          initialContent={hobbiesContent}
          title='Edit Hobbies Section'
          label='Hobbies'
        />
      )}
      {isPersonalPopupVisible && (
        <EditPersonalPopup
          onClose={closePersonalPopup}
          onSave={handleUpdatePersonalInfo}
          initialInfo={personalInfo}
        />
      )}
      {isAppearancePopupVisible && (
        <EditAppearancePopup
          onClose={closeAppearancePopup}
          onSave={handleUpdateAppearanceInfo}
          initialInfo={appearanceInfo}
        />
      )}

      {isCompanyPopupVisible && (
        <AddPopup
          onClose={closeCompanyPopup}
          onAdd={handleUpdateCompany}
          initialContent={companyName}
          title='Edit Company Name'
          label='Company Name'
        />
      )}

      {isLocationPopupVisible && (
        <AddPopup
          onClose={closeLocationPopup}
          onAdd={handleUpdateLocation}
          initialContent={location}
          title='Edit Location'
          label='Location'
        />
      )}

      {isIndustryJobPopupVisible && (
        <AddPopup
          onClose={closeIndustryJobPopup}
          onAdd={handleUpdateCrewIndustryJob}
          initialContent={industryJobContent}
          title='Edit Business Name'
          label='Business Name'
        />
      )}
      <Alert
        openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage}
      />
    </>
  );
};

export default ProfileInfo;
